module.exports = __webpack_public_path__ + "img/greenberg.05e60a75.png";